




















import Proxyable from '@/mixins/proxyable';

import { get } from 'vuex-pathify';
import { mapActions } from 'vuex';

import { IQuoteServiceTemplate, IServicePriceComputation } from '@/models';
import { ErrorManager } from '@/models/error';
import { PropType } from 'vue';

export default Proxyable.extend({
  name: 'QuoteServiceComputationSearch',

  props: {
    serviceTemplateId: { type: Number, required: true },
    type: {
      type: String as PropType<'days' | 'price'>,
      default: 'days',
      validator: (type: any) => ['days', 'price'].includes(type)
    },
    prependInnerIcon: { type: String, default: 'mdi-database-search' },
    clearable: { type: Boolean, default: true }
  },

  data: () => ({
    isLoading: false,
    search: '' as string,
    errorMessage: ''
  }),

  computed: {
    getQuoteServiceTemplateById: get<(id: number) => IQuoteServiceTemplate>(
      'quoteTemplate/getQuoteServiceTemplateById'
    ),

    quoteTemplatePriceComputations(): IServicePriceComputation[] {
      const quoteService = this.getQuoteServiceTemplateById(
        this.serviceTemplateId
      );
      switch (this.type) {
        case 'days':
          return quoteService.days_computations;
        case 'price':
        default:
          return quoteService.price_computations;
      }
    }
  },

  methods: {
    ...mapActions({
      fetchQuoteServiceTemplate: 'quoteTemplate/fetchQuoteServiceTemplate'
    }),

    clearInternalErrors() {
      this.errorMessage = '';
    },

    clearAllErrors() {
      this.clearInternalErrors();
      this.$emit('clearAllErrors');
    },

    clearInput() {
      this.clearInternalErrors();
      this.$emit('click:clear');
    }
  },

  mounted() {
    this.clearAllErrors();

    this.isLoading = true;
    this.fetchQuoteServiceTemplate(this.serviceTemplateId)
      .catch(error => {
        this.errorMessage = ErrorManager.extractApiError(error);
      })
      .finally(() => {
        this.isLoading = false;
      });
  }
});
